import '../ChartStyles.css'

interface GenericStatProps {
   onLightDark: string;
   onColor: string;
   onStatNumber: number;
   onStatName: string;
   onPercentage?: boolean;
   onStatSubtext: string;
}

const GenericStat = (props: GenericStatProps) => {
   return (
      <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
         <div style={{display: "flex", flexDirection: "column"}}>
            <p className='generic__stat__number' style={{color: `${props.onLightDark == "light" ? "white" : "rgb(30, 42, 78)"}`}}>{props.onStatNumber}<span style={{fontSize: "14pt", fontWeight: "800"}}>{props.onPercentage ? '%' : ''}</span></p>
            <p className='generic__stat__name' style={{color: `${props.onLightDark == "light" ? "white" : "rgb(30, 42, 78)"}`}}>{props.onStatName}</p>
            <p className='generic__stat__subtext'>{props.onStatSubtext}</p>
         </div>
      </div>
   );
}

export default GenericStat;